import styled from 'styled-components';
import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';

export const PageLayout = styled('div')`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
  color: white;
  position: relative;
  max-width: ${({ theme }) => theme.xlMin};
  width: 100%;
  ${media.mdDown`
    margin-top: 0;
  `}
`;

export const PageContentContainer = styled(Grid)`
  grid-auto-rows: max-content;
`;

export const FeedbackSection = styled(Grid)`
  padding: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  background: ${({ theme }) => theme.color.spaceGray};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdDown`
    border-radius: 0px;
  `}
`;
